import usFlag from "../assets/images/us.jpg";
import spain from "../assets/images/spain.jpg";

const languages = {
  sp: {
    label: "español",
    flag: spain,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
};

export default languages;
